import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';
import { compose } from 'redux';
import withStyles, { WithStyles } from 'react-jss';

export interface IControlRadioProps {
    /** Controlled value */
    checked: boolean;
    /** Disabled status */
    disabled?: boolean;
    /** Focus handler */
    onFocus?: (event) => void;
    /** Blur handler */
    onBlur?: (event) => void;
    /** Change handler */
    onChange?: (event) => void;
    /** Focus field on mount */
    autoFocus?: boolean;
    /** DOM target element name attribute */
    name?: string;
    /** DOM target element id attribute */
    id?: string;
    /** className to append */
    className?: string;
    /** Element to use as wrapper instead of label */
    wrapperElement?: 'span' | 'label' | 'div';
    /** Value */
    value?: string;
    /** Data test id for automated tests */
    testId?: string;
}

interface IState {
}

// @ts-ignore
type Props = IControlRadioProps & WithStyles<any>;

/**
 * HTML radiobutton replacement with extended functionality and styling.
 */
class ControlRadio extends React.Component<Props, IState> {
    static displayName: string = 'ControlRadio';

    private didFocus: boolean = false;
    private innerRef: HTMLInputElement | null = null;

    /**
     * Focuses radiobutton element
     * @public
     */
    focus = () => {
        if (this.innerRef) {
            this.innerRef.focus();
        }
    };

    /**
     * Blurs radiobutton element
     * @public
     */
    blur = () => {
        if (this.innerRef) {
            this.innerRef.focus();
            this.innerRef.blur();
        }
    };

    /**
     * Clicks radiobutton element
     * @public
     */
    click = () => {
        if (this.innerRef) {
            this.innerRef.click();
        }
    };

    render () {
        const Elem = !!this.props.wrapperElement ? this.props.wrapperElement : 'label';

        return (
            <Elem className={classNames('control-radio', this.props.className, this.props.classes.main)}>
                <span className="control-radio-overflow">
                    <input
                        type="radio"
                        checked={this.props.checked}
                        disabled={this.props.disabled}
                        onFocus={this.props.onFocus}
                        onBlur={this.props.onBlur}
                        onChange={this.props.onChange}
                        ref={(node) => {
                            this.innerRef = node;
                            if (node && this.props.autoFocus && !this.didFocus) {
                                node.focus();
                                this.didFocus = true;
                            }
                        }}
                        value={this.props.value}
                        name={this.props.name}
                        id={this.props.id}
                        data-testid={this.props.testId}
                    />
                    <span className={classNames('control-radio-radio', this.props.classes.radio, {
                        active: this.props.checked,
                        disabled: this.props.disabled,
                    })}>
                        <span/>
                    </span>
                </span>
            </Elem>
        );
    }
}

const styles = (theme) => {
    return {
        main: {
            '&.layout-default': {},
        },
        radio: {
            '&.active': {
                backgroundColor: [[theme.colors.primary], '!important'],
            },
        },
    };
};

export default compose<React.ComponentClass<IControlRadioProps>>(
    // @ts-ignore
    withStyles(styles, { injectTheme: true })
)(ControlRadio);
